import React, { Component } from "react";
import PropTypes from "prop-types";
import Button from "../button/button";
import Input from "../Input/Input";

class UploadFile extends Component {
	constructor(props) {
		super(props);
		this.state = {
			errors: {
				file: undefined
			}
		};

		// Create Input File reference
		this.inputFileRef = React.createRef();

		// Bind
		// this.handleFilesChange = this.handleFilesChange.bind(this);

		console.log("upload", props);
	}

	clickinInputFile(evt) {
		evt.preventDefault(); // Prevent
		const node = this.inputFileRef.current;

		node.click();
	}

	validateType(fileType) {
		const { accept } = this.props;
		if (accept) {
			let typesAccept = accept.split(",");
			for (let i = 0; i < typesAccept.length; i++) {
				if (fileType === typesAccept[i]) {
					return true;
				}
			}
			return false;
		} else {
			return true;
		}
	}

	handleFilesChange(files) {
		const { onChange } = this.props;
		const { errors } = this.state;

		if (files.length) {
			// var FR = new FileReader();
			let fileSize = files[0].size / 1024 / 1024;
			console.log("Tamanho do arquivo: " + fileSize);
			if (fileSize <= 5 && this.validateType(files[0].type)) {
				errors.file = "";
				this.setState({ files, name: files[0].name, errors });
				console.log(files[0]);

				if (onChange) {
					onChange(files[0]);
					console.log(files[0]);
				}
			} else {
				onChange(undefined);
				if (fileSize > 5) {
					errors.file = "Seu arquivo deve ter no máximo 5MB";
				} else {
					errors.file = "O formato de arquivo não é suportado";
				}
				this.setState({ errors, name: "" });
			}
		}
	}

	render() {
		const { className, children, onChange, label, disabled, ...props } = this.props;
		const { name, errors } = this.state;

		return window.screen.availWidth <= 468 ? (
			<div
				className={`upload-file-component__input${label ? " upload-file-component__input-label" : ""
					}`}
			>
				<div className="col-xs-16 no-padding no-margin">
					<div className="col-xs-16 no-padding no-margin">
						<Input
							className="input-with-icon"
							label={label}
							value={name}
							errorMessage={errors.file}
							disabled={true}
						/>
					</div>
					<div className="col-xs-16 no-padding margin-top">
						<Button
							disabled={disabled}
							onClick={e => this.clickinInputFile(e)}
							className={`${className} btn-gray-lg-o`}
						>
							{children || "Escolher arquivo"}
						</Button>
					</div>
					<div className="col-xs-16 no-padding no-margin">
						<input
							type="file"
							ref={this.inputFileRef}
							onChange={e => this.handleFilesChange(e.target.files)}
							className="hidden"
							{...props}
						/>
					</div>
				</div>
			</div>
		) : (
			<div
				className={`upload-file-component__input${label ? " upload-file-component__input-label" : ""
					}`}
			>
				<Input
					className="input-with-icon upload-file-component__input"
					label={label}
					value={name}
					errorMessage={errors.file}
					disabled={true}
				/>

				<Button
					disabled={disabled}
					onClick={e => this.clickinInputFile(e)}
					className={`${className} btn-gray-lg-o`
					}
				>
					{children || "Escolher arquivo"}
				</Button>

				<input
					type="file"
					ref={this.inputFileRef}
					onChange={e => this.handleFilesChange(e.target.files)}
					className="hidden"
					{...props}
				/>
			</div>
		);
	}
}

UploadFile.propTypes = {
	onChange: PropTypes.func
};

UploadFile.defaultProps = {
	className: "btn"
};

export default UploadFile;
